define('common/components/product-bar/views/product-bar-light',[
    'app',
    'i18next',
    'vue',
    'common/components/vue-wrapper/helpers/mount-vue-component',
    '@discoveryedu/nebula-components',
    'common/components/product-bar/behaviors/quicklist',
    'common/components/product-bar/behaviors/autosuggest'
], function (
    app,
    i18next,
    Vue,
    mountVueComponent,
    NebulaComponents,
    QuicklistBehavior,
    AutosuggestBehavior
) {
    "use strict";

    return Mn.LayoutView.extend({

        "searchSuggestions": null,

        "channels": {
            "learnRouter": Backbone.Radio.channel('learn-router')
        },

        "behaviors": {
            "Quicklist": {
                "behaviorClass": QuicklistBehavior
            },
            "AutoSuggest": {
                "behaviorClass": AutosuggestBehavior
            }
        },

        "initialize": function() {
            this.searchSuggestions = Vue.reactive({
                "data": [],
                "user_suggestions": []
            });

            var $embeddedProductBar = $('.embedded-product-bar');

            if ($embeddedProductBar.length) {
                var productBarData = $embeddedProductBar.data(),
                    self = this,
                    searchQuery = productBarData.searchQuery || '';

                this.vueInstance = mountVueComponent(
                    NebulaComponents.NebulaProductBar,
                    '.embedded-product-bar',
                    {
                        "embed": "true"
                    },
                    {
                        "search": function() {
                            return Vue.h(NebulaComponents.NebulaProductBarSearch, {
                                "action": "/learn/search",
                                "additionalParams": productBarData.additionalParams,
                                "homeLink": "/learn/search/embedded",
                                "langCode": app.initData.get("locale"),
                                "searchInputId": "nebula-product-bar__search-input",
                                "suggestions": self.searchSuggestions.data,
                                "typeList": app.initData.get("suggestion_types") || null,
                                "userSuggestions": self.searchSuggestions.user_suggestions,
                                "onClearSearchBox": function() {
                                    searchQuery = '';
                                }
                            }, {
                                "searchInput": function(searchInputSlotProps) {
                                    var placeholder = i18next.t('Search for resources…');
                                    return Vue.h(NebulaComponents.NebulaInput, {
                                        // Attributes
                                        "class": "nebula-product-bar__search-input",
                                        "autocomplete": "off",
                                        "id": "nebula-product-bar__search-input",
                                        "placeholder": placeholder,

                                        // Props
                                        "maxlength": 200,
                                        "name": "q",
                                        "size": "s",
                                        "text": searchQuery,

                                        // Listeners
                                        "onKeydown": function(e) {
                                            searchInputSlotProps.emitInputKeyDownEvents(e);
                                        },
                                        "onInput": function(value) {
                                            searchQuery = value;
                                        },
                                        "onKeyup": _.debounce(function(e) {
                                            // this is kind of weird to send the search suggestions into the behavior
                                            // function to get updated but it works, and I didnt know what else to do
                                            // the view and behavior function dont have the same varible scope
                                            self.triggerMethod('updateSearchSuggestions', e, self.searchSuggestions);
                                        }, 250)
                                    });
                                }
                            });
                        }
                    }
                );
            }
        }
    });
});

